// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"29892e69","453":"9e856832","455":"74aaf213"}[chunkId] + ".chunk.js";
};